module.exports = __webpack_public_path__ + "media/images/plans/propose_restaurant/hall-img-72kou-48e60f72e791493b8ca1e938cebb59c6.jpg";